import './Search.css'

function Search({ selectedSubcategory, searchQuery, setSearchQuery, consumer }) {
    return (
        <>
            <input
                type="text"
                className='search_field'
                placeholder={
                    consumer
                        ?
                        consumer.language === 'english'
                            ?
                            `Search ${selectedSubcategory ? selectedSubcategory.engName : ''}`
                            :
                            `${selectedSubcategory ? selectedSubcategory.name : ''} খুজুন`
                        :
                        `${selectedSubcategory ? selectedSubcategory.name : ''} খুজুন`
                }
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
            />
        </>
    )
}

export default Search